// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"95":"83c8222fc30e16cc","157":"1b354b2ebd7de8fa","246":"2202fc1352a30bb9","771":"abf3cf94859fef9e"}[chunkId] + ".js";
};